// Route changes share one browser session. Keep unfinished AI work when changing areas.
const drafts = new Map();
export const readAIDraft = userId => drafts.get(userId) || {};
export const rememberAIDraft = (userId, value) => { if (userId) drafts.set(userId, value); };
export const clearAIDrafts = () => drafts.clear();
